import Bugsnag from '@bugsnag/js'
import pSeries from 'p-series'
import {
    type MutationResolvers,
    type UploadDocumentMutation,
    UploadDocumentDocument,
} from '../../../../../generated/graphql'
import { userAgentParser } from '@edge/spark/utils'

const uploadDocuments: MutationResolvers['uploadDocuments'] = async (_root, { docs }, { client }) => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    if (!docs.length) {
        throw new Error('Missing docs')
    }

    const os = userAgentParser.getOS().name

    if (os !== 'Windows') {
        Bugsnag.notify(new Error('uploadDocuments'), (event) => {
            event.severity = 'info'
            event.addMetadata('docs', { docs })
        })
    }

    try {
        await pSeries(
            docs.map((doc) => async () => {
                try {
                    const res = await client.mutate<UploadDocumentMutation>({
                        mutation: UploadDocumentDocument,
                        variables: { input: doc },
                    })

                    if (res?.data?.uploadDocument) {
                        return res
                    }

                    throw new Error('Invalid response')
                } catch (e) {
                    return Promise.reject(e)
                }
            }),
        )

        return true
    } catch (e) {
        return false
    }
}

export default uploadDocuments
